module.exports = __webpack_public_path__ + "static/img/produce10.957a5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce10.png
// module id = 140
// module chunks = 4